import { QUERY_KEYS } from 'api/query-keys';
import { dashboardService } from 'api/services';
import { useQuery } from 'react-query';
import { CACHE_TIME_LONG } from 'shared/react-query/query-defaults';
import { Site } from '../../../../shared/hooks';

export const useGetNotPlannedWork = (site: Site) => {
  const queryFn = async () => await dashboardService.getNotPlannedWork(site);

  return useQuery(QUERY_KEYS.notPlannedWork(), queryFn, { cacheTime: CACHE_TIME_LONG });
};
